import React, { useState, useEffect } from 'react'
import { Dialog, DialogContent, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { erroresPesado } from '../../actions/constantesErroresPesado'

export default function DialogoErrorPesado (props) {
  const { cpe, borrarCpe, show, onBlurInput, updateShow = null, showToast, showCancel = true } = props
  const [open, setOpen] = useState(false)
  const [seconds, setSeconds] = useState(18)

  if (!open && cpe && cpe.error) {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    if (erroresPesado[cpe.errorDescripcion]) {
      showToast(erroresPesado[cpe.errorDescripcion], cpe.numero)
    } else {
      showToast(cpe.errorDescripcion, cpe.numero)
    }
    borrarCpe(cpe.numero)
    if (updateShow) { updateShow(false) }
    onBlurInput()
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0 && cpe && cpe.error) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        handleClose()
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <Dialog
      maxWidth={'md'}
      fullWidth
      open={open}
    >
      { showCancel && <IconButton
        onClick={handleClose}
        style={{
          margin: '0',
          padding: '15px',
          justifyContent: 'right'
        }}
      >
        <CloseIcon />
      </IconButton>
      }
      <div style={{ padding: '25px 0', backgroundColor: '#3f51b5', color: '#ffffff', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem' }}>¡Atención!</h1>
      </div>
      <DialogContent style={{ padding: '10%', fontSize: '2.4rem', textAlign: 'center' }}>
        <h2>Error en la lectura de la CTG número {cpe.numero}</h2>
        <h2 style={{ fontWeight: '600' }} > {cpe.errorDescripcion}</h2>
        <br />
        { (show) &&
          <h2>
            En breve solucionaremos el problema, sepa disculpar.
          </h2>
        }
      </DialogContent>
    </Dialog>
  )
}
